<template>
  <div style="background-color: #ffffffd9">
  <div class="backgimg"></div>
	<div class="container">
    <div class="row">
      <div class="col-12 col-md-2 mb-4 mb-md-0 py-4" data-aos="fade-up">
        <div
          class="sidebar d-flex flex-column theme-border-radius theme-bg-white theme-box-shadow sticky"
        >
          <a
            href="/about-us"
            class="border-bottom p-3 theme-text-accent-one"
            >About us</a
          ><a href="/contact-us" class="border-bottom p-3 theme-text-accent-one"
            >Contact us</a
          ><a href="/privacy-policy" class="border-bottom p-3 theme-text-accent-one"
            >Privacy Policy</a
          >
          <a href="/terms-conditions" class="border-bottom p-3 theme-text-accent-one"
            >Terms of use</a
          >
          </div>
        </div>
        <div
          class="col-12 col-md-10 privacyContent py-4"
          v-html="termsContent"
        ></div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";

import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";

export default {
  data() {
    return {
      termsContent: "",
      getTermsUrl: "",
      termsType: "",
      getLangname: "",
    };
  },

  methods: {
    getConfig() {
      // let getConfigData = this.$store.state.data

      // let portalLocal = localStorage.getItem("portalData")
      // let getConfigData = JSON.parse(portalLocal)
      const getConfigData = getConfigDataFromLocalStorage();
      if (getConfigData) {
        let locale = this.getLangname;
        let getsiteContentData = getConfigData.payload.portal_configuration.site_content_data[locale];
        if(getsiteContentData && getsiteContentData?.termsofuse){
          this.getTermsUrl = getsiteContentData.termsofuse.url;
          this.termsType = getsiteContentData.termsofuse.type;
          // console.log(getConfigData, 'head...about..1..')
          // console.log(this.getTermsUrl, 'head...about..2..')

          this.getConfigFunc();
        }
      }
    },

    getConfigFunc() {
      axios
        .get(this.getTermsUrl, {
          headers: {
            "Content-Type": this.termsType,
          },
        })
        .then((response) => {
          const cleanedResponse = response.data.replace(/text-center/g, "");
          this.termsContent = cleanedResponse;
          // console.log(response.data, "getTermsUrlrgetTermsUrlrgetTermsUrlrab.....")
        })

        .catch((error) => {
          console.log(error, "erroroor.....");
        });
    },
    updateContent() {
      this.getLangname = this.$i18n.locale;
      console.log(this.$i18n.locale, "getcontententUrl...1");
      this.getConfig();
    },
  },
  watch: {
    "$i18n.locale": {
      handler: function () {
        this.updateContent();
        // this.getConfig();
        // this.getConfigFunc();
      },
      deep: true,
    },
  },

  created() {
    this.updateContent();
    // this.getConfig();
    // this.getConfigFunc();
  },
};
</script>
<style scoped>
@media screen and (max-width: 480px) {
  :deep(.footr-content-wrap p) {
    text-align: justify;
  }
}
:deep(.privacyContent) {
  text-align: justify;
}
:deep(.privacyContent ul) {
  list-style: disc !important;
  padding-left: 2rem !important;
  margin: 10px 0px !important;
}
:deep(.privacyContent h2 + p) {
  margin-top: 20px;
}
:deep(.privacyContent p) {
  margin-bottom: 1rem !important;
  margin-top: 1rem !important;
}
:deep(.privacyContent h4) {
  font-size: 24px !important;
}
:deep(.privacyContent h2) {
  font-size: 30px !important;
}
:deep(.privacyContent h5) {
  font-size: 20px !important;
  margin-top: 22px !important;
}
.sticky {
  position: sticky;
  top: 15%;
  background-color: #fff !important;
}
.theme-box-shadow {
  box-shadow: 0 0 0.8rem rgba(52, 53, 52, 0.15);
}
.theme-border-radius,
.theme-border-radius-top {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}
.theme-text-accent-one {
  color: #343534;
}
a {
  text-decoration: none;
}
.backgimg{
  /* background-image: url(https://www.columbiathreadneedle.com/uploads/2022/07/7261494b4139321e43bea28c6616b256/jumbo-jet-taking-off.jpg); */
  background-image: url(../assets/images/footer-2.jpg);

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 350px;
  width: 100%;
}
</style>